import { combineReducers } from '../lib/imports';

const initialState = {
  regular: {
    questions: [
      ['3x10', 6, 2, 4],
      ['2x7', 2, 6, 2],
      ['5x6', 2, 7, 2],
      ['8x4', 2, 4, 9],
    ],
    options: [
      [2, 3, 4, 10],
      [2, 11, 5, 14],
      [7, 14, 20, 5],
      [6, 9, 11, 19],
    ],
    answers: [3, 11, 20, 11],
  },
  playoffs: {
    questions: [
      ['2x8', 2, 5, 3],
      ['5x3', 5, 7, 4],
      ['6x2', 3, 9, 2],
      ['12x1', 4, 10, 6],
    ],
    options: [
      [10, 4, 8, 20],
      [4, 6, 2, 30],
      [2, 11, 5, 14],
      [30, 7, 2, 18],
    ],
    answers: [10, 6, 11, 7],
  },
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_START':
    case 'SEND_QUIZ_ANSWER_START':
    case 'SEND_USERNAME_START':
    case 'FETCH_NOTIFICATIONS_START':
    case 'SEND_NOTIFICATIONS_START':
      return true;
    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_QUIZ_DATA_FAILURE':
    case 'SEND_QUIZ_ANSWER_SUCCESS':
    case 'SEND_QUIZ_ANSWER_FAILURE':
    case 'SEND_USERNAME_SUCCESS':
    case 'SEND_USERNAME_FAILURE':
    case 'FETCH_NOTIFICATIONS_SUCCESS':
    case 'FETCH_NOTIFICATIONS_FAILURE':
    case 'SEND_NOTIFICATIONS_SUCCESS':
    case 'SEND_NOTIFICATIONS_FAILURE':
      return false;
    default:
      return state;
  }
};

const questions = (state = initialState.regular.questions, action) => {
  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.questions : initialState.regular.questions;
    default:
      return state;
  }
};

const options = (state = initialState.regular.options, action) => {
  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.options : initialState.regular.options;
    default:
      return state;
  }
};

const answers = (state = initialState.regular.answers, action) => {
  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.answers : initialState.regular.answers;
    default:
      return state;
  }
};

const onboardingStep = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return state + (action.resp ? 1 : 0);
    case 'FETCH_USER_SUCCESS':
      return state + (action.resp.user.username ? 1 : 0);
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return state + (action.resp.tnhcUserReminders !== undefined ? 1 : 0);
    case 'SET_CORRECT_ANSWER':
    case 'SET_USERNAME':
    case 'SET_COMPLETED_ONBOARDING':
    case 'SEND_NOTIFICATIONS_SUCCESS':
    case 'SEND_NOTIFICATIONS_FAILURE':
      return state + 1;
    default:
      return state;
  }
};

const initialStep = (state = 0, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return state + (action.resp ? 1 : 0);
    case 'FETCH_USER_SUCCESS':
      return state + (action.resp.user.username ? 1 : 0);
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return state + (action.resp.tnhcUserReminders !== undefined ? 1 : 0);
    default:
      return state;
  }
};

const hasAnswered = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;
    case 'SET_CORRECT_ANSWER':
      return true;
    case 'FETCH_QUIZ_DATA_FAILURE':
      return false;
    default:
      return state;
  }
};

const lockout = (state = false, action) => {
  switch (action.type) {
    case 'SET_LOCKOUT':
      return true;
    default:
      return state;
  }
};

const hasUsername = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_USER_SUCCESS':
      return !!action.resp.user.username;
    case 'SET_USERNAME':
      return true;
    case 'FETCH_USER_FAILURE':
      return false;
    default:
      return state;
  }
};

const hasNotificationPref = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return action.resp.tnhcUserReminders !== undefined;
    case 'SEND_NOTIFICATIONS_SUCCESS':
      return true;
    case 'FETCH_NOTIFICATIONS_FAILURE':
      return false;
    default:
      return state;
  }
};

const attempts = (state = 0, action) => {
  switch (action.type) {
    case 'SET_INCORRECT_ANSWER':
      return state + 1;
    default:
      return state;
  }
};

const selectedAnswer = (state = null, action) => {
  switch (action.type) {
    case 'SET_SELECTED_ANSWER':
      return action.resp;
    case 'SET_INCORRECT_ANSWER':
      return null;
    default:
      return state;
  }
};

const correctAnswer = (state = false, action) => {
  switch (action.type) {
    case 'SET_CORRECT_ANSWER':
      return true;
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;
    default:
      return state;
  }
};

const errorCode = (state = '', action) => {
  switch (action.type) {
    case 'SEND_USERNAME_FAILURE':
      return action.err;
    case 'SEND_ERROR_CODE_RESET':
    case 'SEND_USERNAME_SUCCESS':
      return '';
    default:
      return state;
  }
};

const usernameValidationErr = (state = false, action) => {
  switch (action.type) {
    case 'SET_USERNAME_VALIDATION_ERR':
      return action.resp;
    default:
      return state;
  }
};

const username = (state = '', action) => {
  switch (action.type) {
    case 'FETCH_USER_SUCCESS':
      return action.resp.user.username;
    case 'SET_USERNAME':
      return action.resp;
    default:
      return state;
  }
};

const updateUsernameStatus = (state = false, action) => {
  switch (action.type) {
    case 'SEND_USERNAME_SUCCESS':
      return true;
    case 'RESET_USERNAME_STATUS':
      return false;
    default:
      return state;
  }
};

const resetUserNameAttemptStatus = (state = false, action) => {
  switch (action.type) {
    case 'SET_USERNAME_ATTEMPT_FAILURE':
      return true;
    case 'SET_USERNAME_ATTEMPT_SUCCESS':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  questions,
  options,
  answers,
  isFetching,
  initialStep,
  onboardingStep,
  hasAnswered,
  hasUsername,
  hasNotificationPref,
  attempts,
  selectedAnswer,
  correctAnswer,
  usernameValidationErr,
  errorCode,
  username,
  lockout,
  updateUsernameStatus,
  resetUserNameAttemptStatus,
});
